<div id="audioCollection" *ngIf="!useAudioContext">
  <eocm-audio-track *ngFor="let audio of audioList" [audio]="audio"></eocm-audio-track>
</div>

<div id="appleAudioCollection" *ngIf="useAudioContext">
  <eocm-apple-audio-track *ngFor="let audio of audioList" [audio]="audio" [audioContext]="audioContext"></eocm-apple-audio-track>
</div>
